// ABOUTME: Coloured badge wrapping the SVG logo for a melding type.
// ABOUTME: Background colour is derived from the logo's dominant colour (via useTypeColors), or generated from the label hash for items without a logo.

import { Box, useTheme } from "@mui/material";
import { findMeldingType, getMeldingTypeLogo } from "./meldingTypes";
import { useTypeColors } from "./useTypeColors";

const initials = (label) => {
    if (!label) return "";
    const parts = label.split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
};

const MeldingTypeBadge = ({ typeId, size = 28, withLabel = false }) => {
    const theme = useTheme();
    const mode = theme.palette.mode;
    const entry = findMeldingType(typeId);
    const { bg, color } = useTypeColors(typeId, mode);
    if (!entry) return null;

    const logo = getMeldingTypeLogo(typeId, Math.round(size * 0.7));

    const badge = (
        <Box
            sx={{
                width: size,
                height: size,
                borderRadius: size / 4,
                background: bg,
                color: color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: "Roboto, sans-serif",
                fontWeight: 700,
                fontSize: size <= 20 ? 10 : 11,
                flexShrink: 0,
                overflow: "hidden",
            }}
        >
            {logo || initials(entry.label)}
        </Box>
    );

    if (!withLabel) return badge;

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {badge}
            <Box sx={{ fontSize: 13, color: color, fontWeight: 600, fontFamily: "Roboto, sans-serif" }}>
                {entry.label}
            </Box>
        </Box>
    );
};

export default MeldingTypeBadge;
